import { Phone } from "lucide-react";

const LOGO_URL = "/logo_transparent.png";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-[#0F0F0F] border-t border-white/[0.06]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
          {/* Logo & Brand */}
          <div className="md:col-span-5">
            <img
              src={LOGO_URL}
              alt="Warner VTC"
              className="w-28 mb-6"
            />
            <p className="text-white/30 text-sm font-light tracking-wide leading-[1.8] max-w-xs">
              Votre chauffeur privé d'exception en Finistère. 
              Service VTC haut de gamme basé à Saint-Renan.
            </p>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-3">
            <h4 className="text-gold/50 text-[10px] uppercase tracking-[0.3em] mb-8">
              Navigation
            </h4>
            <div className="flex flex-col gap-4">
              {["Services", "Véhicule", "Réservation", "Contact", "Partenaires"].map((label) => (
                <a
                  key={label}
                  href={`#${label.toLowerCase().replace("é", "e").replace("è", "e")}`}
                  className="text-white/25 text-sm hover:text-gold transition-colors duration-500 tracking-wider font-light"
                >
                  {label}
                </a>
              ))}
            </div>
          </div>

          {/* Contact Info */}
          <div className="md:col-span-4">
            <h4 className="text-gold/50 text-[10px] uppercase tracking-[0.3em] mb-8">
              Contact
            </h4>
            <div className="flex flex-col gap-4">
              <a
                href="tel:0676806203"
                data-testid="footer-phone"
                className="flex items-center gap-3 text-gold/70 text-sm hover:text-gold transition-colors duration-300"
              >
                <Phone size={13} strokeWidth={1.2} />
                <span className="tracking-wider">06 76 80 62 03</span>
              </a>
              <a
                href="mailto:warnervtc@gmail.com"
                data-testid="footer-email"
                className="text-white/25 text-sm hover:text-gold transition-colors duration-300 tracking-wider font-light"
              >
                warnervtc@gmail.com
              </a>
              <p className="text-white/15 text-sm tracking-wider font-light">
                Saint-Renan, Finistère
              </p>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="gold-line mt-16 mb-8 opacity-30" />
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/15 text-[11px] tracking-[0.15em]">
            &copy; {currentYear} Warner VTC — Tous droits réservés
          </p>
          <div className="flex items-center gap-6">
            <a
              href="/mentions-legales"
              data-testid="footer-legal-link"
              className="text-white/15 text-[11px] tracking-[0.15em] hover:text-gold/50 transition-colors duration-300"
            >
              Mentions légales
            </a>
            <a
              href="/politique-de-confidentialite"
              data-testid="footer-privacy-link"
              className="text-white/15 text-[11px] tracking-[0.15em] hover:text-gold/50 transition-colors duration-300"
            >
              Politique de confidentialité
            </a>
            <p className="text-white/10 text-[11px] tracking-[0.15em]">
              Service non conventionné
            </p>
          </div>
        </div>

        {/* DriveFlow Web credit */}
        <div className="mt-8 flex items-center justify-center">
          <a
            href="https://www.driveflowtechnologies.fr/web"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-driveflow-credit"
            className="group flex items-center gap-3 opacity-60 hover:opacity-90 transition-opacity duration-500"
          >
            <span className="text-white/40 text-[10px] tracking-[0.15em]">Conception par</span>
            <span className="text-sm font-bold tracking-tight">
              <span className="text-white">Drive</span>
              <span className="text-[#4285F4]">Flow</span>
              <span className="text-white/50 font-normal ml-1">Web</span>
            </span>
          </a>
        </div>
      </div>
    </footer>
  );
}
